import { takeShareCode, clearShareCode } from "@/lib/share";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullLoader } from "@/components/ProtectedRoute";
import { CheckCircle2 } from "lucide-react";
import { getAdSource, clearAdSource } from "@/lib/adSource";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [handoffDone, setHandoffDone] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.slice(1));
    const session_id = params.get("session_id");
    const referral_code = localStorage.getItem("itz_ref") || null;
    const handoff = new URLSearchParams(window.location.search).get("handoff");
    api.post("/auth/google-session", { session_id, referral_code, share_code: takeShareCode(), handoff, source: getAdSource() })
      .then(({ data }) => {
        localStorage.removeItem("itz_ref"); clearShareCode();
        clearAdSource();
        setUser(data);
        if (data.account_restored) toast.success("Willkommen zurück! Dein Konto wurde wiederhergestellt 💖", { duration: 8000 });
        if (handoff) { window.history.replaceState(null, "", "/feed"); setHandoffDone(true); return; }
        window.history.replaceState(null, "", "/feed");
        navigate("/feed", { replace: true });
      })
      .catch((e) => {
        toast.error(formatErr(e));
        setUser(false);
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  if (handoffDone) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 noise-bg" data-testid="handoff-done">
        <div className="max-w-sm text-center space-y-4 bg-white rounded-3xl p-8 border border-pink-100">
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
          <h1 className="text-2xl font-extrabold">Angemeldet!</h1>
          <p className="text-sm text-slate-600">Du kannst dieses Fenster schließen und zur itzPlay-App auf deinem Home-Bildschirm zurückkehren – dort bist du gleich automatisch eingeloggt.</p>
          <button onClick={() => navigate("/feed", { replace: true })} data-testid="handoff-continue-btn" className="w-full h-11 rounded-full pink-gradient text-white font-bold text-sm">Hier im Browser weiter</button>
        </div>
      </div>
    );
  }
  return <FullLoader />;
}
